import React from "react";

export default function SQL_FROM() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_FROM</h1>
      <p>This is the SQL_FROM component generated from the SQL JSON.</p>
    </div>
  );
}
